export default {
  getWaterDepositsTable: state => state.waterDepositsTable,
  getWaterDepositsMap: state => state.waterDepositsMap,
  getWaterIntakesTable: state => state.waterIntakesTable,
  getWaterIntakesMap: state => state.waterIntakesMap,
  getApprovedSitesTable: state => state.approvedSitesTable,
  getApprovedSitesMap: state => state.approvedSitesMap
};
